(function () {
    var GROUP_PROPERTY = '_group_id';
    var isRunning = false;
    var originalFetch = window.fetch;

    function log() {
        if (window.location.search.includes('debug_cart=true')) {
            console.log.apply(console, ['[GroupCart]'].concat(Array.prototype.slice.call(arguments)));
        }
    }

    function cartUrl(path) {
        var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        // Shopify standard is /cart.js or /cart/change.js
        if (path === 'js') return root + 'cart.js';
        return root + 'cart/' + path;
    }

    function getCart() {
        return originalFetch(cartUrl('js')).then(function (response) {
            return response.json();
        });
    }

    function removeItem(itemKey) {
        log('Removing item:', itemKey);
        return originalFetch(cartUrl('change.js'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: itemKey,
                quantity: 0
            })
        });
    }

    function getRemovedItemInfo(url, options) {
        if (!url) return null;
        var urlString = url.toString();
        
        // Match /cart/change, /cart/change.js, /cart/update, /cart/update.js
        var isChange = urlString.includes('/cart/change');
        var isUpdate = urlString.includes('/cart/update');
        
        if (!isChange && !isUpdate) {
            return null;
        }

        if (!options || !options.body) {
            return null;
        }

        try {
            var data = typeof options.body === 'string' ? JSON.parse(options.body) : options.body;

            if (isChange && Number(data.quantity) === 0) {
                return {
                    id: data.id,
                    line: data.line
                };
            }
            
            if (isUpdate && data.updates) {
                for (var key in data.updates) {
                    if (Number(data.updates[key]) === 0) {
                        return { id: key };
                    }
                }
            }
        } catch (error) { }

        return null;
    }

    function getGroupIdFromCart(cart, removedInfo) {
        var item = null;
        if (removedInfo.line) {
            item = cart.items[parseInt(removedInfo.line) - 1];
        } else if (removedInfo.id) {
            item = cart.items.find(function (cartItem) {
                return (
                    cartItem.key === removedInfo.id ||
                    cartItem.variant_id == removedInfo.id ||
                    cartItem.handle === removedInfo.id ||
                    cartItem.id == removedInfo.id
                );
            });
        }

        if (!item || !item.properties || !item.properties[GROUP_PROPERTY]) {
            log('Item or group property not found', item);
            return null;
        }

        return item.properties[GROUP_PROPERTY];
    }

    function removeItemsByGroup(groupId, removedItemKey) {
        if (!groupId || isRunning) return;

        isRunning = true;
        log('Starting group removal for:', groupId);

        getCart()
            .then(function (cart) {
                var itemsToRemove = cart.items.filter(function (item) {
                    return (
                        item.key !== removedItemKey &&
                        item.properties &&
                        item.properties[GROUP_PROPERTY] == groupId
                    );
                });

                log('Items to remove in group:', itemsToRemove.length);

                if (itemsToRemove.length === 0) {
                    isRunning = false;
                    return;
                }

                var promise = Promise.resolve();
                itemsToRemove.forEach(function (item) {
                    promise = promise.then(function () {
                        return removeItem(item.key);
                    });
                });

                return promise.then(function () {
                    log('Group removal complete, reloading...');
                    window.location.reload();
                });
            })
            .catch(function (error) {
                console.error('Group removal error:', error);
                isRunning = false;
            });
    }

    window.fetch = function (url, options) {
        var fetchArgs = arguments;
        var removedInfo = getRemovedItemInfo(url, options);

        if (!removedInfo || isRunning) {
            return originalFetch.apply(this, fetchArgs);
        }

        log('Intercepted removal fetch:', url.toString(), JSON.stringify(removedInfo));

        return getCart().then(function (cartBeforeRemove) {
            var groupId = getGroupIdFromCart(cartBeforeRemove, removedInfo);
            var removedItemKey = null;

            log('Found group ID:', groupId);

            if (groupId) {
                if (removedInfo.line) {
                    var item = cartBeforeRemove.items[parseInt(removedInfo.line) - 1];
                    if (item) removedItemKey = item.key;
                } else {
                    removedItemKey = removedInfo.id;
                }
                
                log('Item key to exclude:', removedItemKey);

                return originalFetch.apply(window, fetchArgs).then(function (response) {
                    log('Original removal responded. Status:', response.status, 'OK:', response.ok);
                    
                    if (response.ok) {
                        log('Scheduling group cleanup...');
                        setTimeout(function () {
                            removeItemsByGroup(groupId, removedItemKey);
                        }, 500);
                    }
                    return response;
                }).catch(function(err) {
                    log('Original removal fetch failed:', err);
                    throw err;
                });
            }

            return originalFetch.apply(window, fetchArgs);
        }).catch(function(err) {
            log('Error in fetch interceptor:', err);
            return originalFetch.apply(window, fetchArgs);
        });
    };
})();
